module.exports = __webpack_public_path__ + "static/media/phosphorus.c16d8acd.svg";